import { MenuItem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledMenuItem = styled(MenuItem) `
  background-color: ${({ disabled }) => disabled && themeGet('colors.gray.50')};
`;
